export const getContextIds = (cloudId: string, activationId: string) => {
    return [`ari:cloud:jira:${cloudId}:workspace/${activationId}`];
};
